import type { FSNode, ProjectFileRoot } from '../types/fs-types';
import type { LVGLSchemaService } from '../containers/xml-editing/services/LVGLSchemaService';

// Reads a single directory's file tree.
export type ReadDirectoryFiles = (dirPath: string) => Promise<FSNode[]>;

// Gathers the main project's directory data plus that of each included project folder
// (declared via <folders> in project.xml), in the precedence order declared in project.xml
// (see `LVGLSchemaService.parseProjectFolders`) - the main project is not guaranteed to be
// first; callers that need to identify it should compare against `projectPath`.
export const gatherProjectRoots = async (
    readDirectoryFiles: ReadDirectoryFiles,
    schemaService?: LVGLSchemaService
): Promise<ProjectFileRoot[]> => {
    if (!schemaService) {
        throw new Error('gatherProjectRoots requires a schemaService to be provided');
    }

    const resolvedFolders: string[] = schemaService.projectFolders;

    return Promise.all(
        resolvedFolders.map(async (folder): Promise<ProjectFileRoot> => {
            const directoryData: FSNode[] = await readDirectoryFiles(folder);
            return { projectPath: folder, directoryData };
        })
    );
};
